export default __webpack_public_path__ + "static/media/quotes-yellow.7e14c271.svg";